import { Container, Row } from "reactstrap";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import SellerForm from "../Forms/FormsControl/FormValidition/SellerForm/BrowserDefault";
import SellerTable from "./SellerTable/HoverableRowsClass";
import DropdownAddForm from "../Forms/FormsControl/FormValidition/DropdownAddForm/BrowserDefault";
import DropdownTable from "./DropdownMenuTable/HoverableRowsClass";

const PaymentFormPage = () => {
  return (
    <>
      <Container className="basic_table" fluid>
        <Breadcrumbs
          mainTitle={"Payment Form"}
          parent={"Manage"}
          title={"payment"}
        />
        {/* <Row></Row> */}
        <DropdownAddForm />
        <DropdownTable
          data={[
            { name: "A", status: "active" },
            { name: "B", status: "active" },
          ]}
        />
      </Container>
    </>
  );
};

export default PaymentFormPage;
